// =====================================================================
// Assessment Center — root application.
//
// Single shared routing system for the whole app: the landing page,
// the four auth pages, and both feature panels are all mounted here.
// AuthContextProvider wraps everything so useAuth() works anywhere
// below it — including inside RequireRole guards used by both panels'
// route trees.
// =====================================================================
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthContextProvider } from "./shared/auth/AuthContext";

import LandingPage from "./features/landing/LandingPage";
import StudentLoginPage from "./features/auth/StudentLoginPage";
import StudentRegisterPage from "./features/auth/StudentRegisterPage";
import InstructorLoginPage from "./features/auth/InstructorLoginPage";
import InstructorRegisterPage from "./features/auth/InstructorRegisterPage";

import { instructorAssessmentCenterRoutes } from "./features/instructor/routes";
import { studentAssessmentCenterRoutes } from "./features/student/routes";

export default function App() {
  return (
    <AuthContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route path="/login/student" element={<StudentLoginPage />} />
          <Route path="/register/student" element={<StudentRegisterPage />} />
          <Route path="/login/instructor" element={<InstructorLoginPage />} />
          <Route path="/register/instructor" element={<InstructorRegisterPage />} />

          {instructorAssessmentCenterRoutes}
          {studentAssessmentCenterRoutes}

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthContextProvider>
  );
}
